// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    .print-only {
      display: block !important;
    }
  }
  
  .print-only {
    display: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/print-buttom.css"],"names":[],"mappings":"AAAA;IACI;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,aAAa;EACf","sourcesContent":["@media print {\r\n    .print-only {\r\n      display: block !important;\r\n    }\r\n  }\r\n  \r\n  .print-only {\r\n    display: none;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
